import { memo } from 'react';
import styled, { type CSSObject } from '@emotion/styled';

import type { ThemeProps } from '@emotion/react';

import { themeFont } from '../../../lib/themeFont';
import useThemeStyles from '../../../lib/useThemeStyles';

import { Wws_WeddingWebsiteV2 } from '../../../types/graphql';
import InlineEditHandler from '../../InlineEdit/InlineEditHandler/InlineEditHandler';
import { buildEditCoupleNameContextMenuButtons } from '../../InlineEdit/InlineEditMessageFactory';
import { getCoupleNames } from '../../../lib/getCoupleNames';

const textShadow = 'text-shadow: 0 0 50px hsla(0,0%,0%,1);';

const SiteTitleWrapper = styled('h1')`
  line-height: 1;
  margin: 16px auto;

  ${themeFont('s1')}

  /* Title is white when over hero photo */
  ${(props: SiteTitleProps): string =>
    props.heroVersion ? `${textShadow} color: white;` : ''}

  ${(props: ThemeProps): CSSObject | undefined =>
    props.theme.components.SiteTitle}
`;

interface SiteTitleProps {
  heroVersion: boolean;
  weddingWebsiteResult?: Wws_WeddingWebsiteV2;
  className?: string | undefined;
}

const SiteTitle = ({
  weddingWebsiteResult,
  heroVersion,
  className,
}: SiteTitleProps) => {
  const themeStyles = useThemeStyles();

  if (
    !weddingWebsiteResult ||
    !weddingWebsiteResult?.firstName ||
    !weddingWebsiteResult?.fianceFirstName
  ) {
    return null;
  }

  const [primaryName, secondaryName] = getCoupleNames({ weddingWebsiteResult }) ?? [];
  const nameSeparator = themeStyles?.config?.nameSeparator
    ? themeStyles.config.nameSeparator
    : '&';

  return (
    <SiteTitleWrapper
      data-testid="header-couple-names"
      heroVersion={heroVersion}
      className={className}
    >
      <InlineEditHandler
        contextMenuButtons={buildEditCoupleNameContextMenuButtons()}
      >
        {`${primaryName} ${nameSeparator} ${secondaryName}`}
      </InlineEditHandler>
    </SiteTitleWrapper>
  );
};

export default memo(SiteTitle);
